export const SeminarLogisticsCardQuestions = [
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "Event Organisation",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "1. Very Poor",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "2. Poor",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "3. Neutral",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "4. Good",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "5. Very Good",
                "isOther": false
            },
        ],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "Knowledge and/or Skills Gained",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "1. Very Poor",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "2. Poor",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "3. Neutral",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "4. Good",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "5. Very Good",
                "isOther": false
            },
        ],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "Overall Event Experience",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "1. Very Poor",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "2. Poor",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "3. Neutral",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "4. Good",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "5. Very Good",
                "isOther": false
            },
        ],
        isOther: false,
    },
]